export default {
    LOAD_COMPANY(state, client) {
        state.items = client
    }
}